"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MountImagePreview = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var LinkPreviewCard_1 = require("../Common/LinkPreview/LinkPreviewCard");
var MountImagePreview = function (mountReactComponent) { return function (props) {
    return mountReactComponent(react_1.default.createElement(ImagePreview, __assign({}, props)));
}; };
exports.MountImagePreview = MountImagePreview;
var ImagePreview = (0, mobx_react_1.observer)(function (props) {
    return (react_1.default.createElement("div", { className: "link-preview-image" },
        react_1.default.createElement(LinkPreviewCard_1.LinkPreviewCard, { clickable: !props.disableChangingLinkSettings(), imageUrl: props.linkPreviewSettingsStore.previewImageUrl, handleOnClick: function () { return props.selectLinkPreview(); } })));
});
